import Axios from 'axios';
import AppConfig from '@/config/AppConfig'

export default {
	createAvatar(params) {
          //console.log(params)
          const a = 'Bearer ' + localStorage.getItem('accessToken')
          Axios.defaults.headers.common['Authorization'] = a
          Axios.defaults.headers.common['Content-Type'] = 'application/json'
          return Axios.post( AppConfig.baseUrl+"/avatar/create",params);
	}
}